export const ALL_LIT = 'SELECT_ALL' as const;

export type MultiFieldValue = typeof ALL_LIT | (number | string)[];

export const isAll = (v: unknown): v is typeof ALL_LIT => v === ALL_LIT;

export const toAll = (): typeof ALL_LIT => ALL_LIT;

export const toArray = (v: MultiFieldValue): (number | string)[] => (Array.isArray(v) ? v : []);

export const toFlag = (v: MultiFieldValue, totalCount?: number): boolean =>
	isAll(v) || (Array.isArray(v) && totalCount ? v.length >= totalCount : false);

export const mapToApi = (v: MultiFieldValue) => (v === ALL_LIT ? -1 : v);

export type Primitive = string | number;

export type MultiValue = { kind: 'all' } | { kind: 'list'; items: Primitive[] };
